export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6ec9c7a858c54fff76b33157ab168300.jpg"
          alt="Clean modern home"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-map-pin-line"></i>
              Serving Melbourne &amp; All Suburbs
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Melbourne&apos;s Trusted{' '}
              <span className="text-teal-600">Cleaning Experts</span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              10 years of professional cleaning across Melbourne and surrounding suburbs. Our dedicated team of 5 delivers spotless results every time — fast booking, trusted service, guaranteed satisfaction.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection('booking')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-all hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Book Cleaning Now
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                View Pricing
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="space-y-4">
              <div className="bg-white rounded-2xl p-6 shadow-xl inline-block">
                <div className="flex items-center gap-3">
                  <div className="text-3xl font-bold text-teal-600">4.9</div>
                  <div className="flex text-yellow-400 text-xl">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-half-fill"></i>
                  </div>
                </div>
                <p className="text-gray-600 mt-2 font-medium">Average Rating</p>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-xl inline-block ml-8">
                <div className="text-3xl font-bold text-teal-600">10 Years</div>
                <p className="text-gray-600 mt-2 font-medium">Trusted in Melbourne</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
